import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux'; // ADD THIS IMPORT
import { Link } from 'react-router-dom';
import styles from './MobileMenuButton.module.css';

const MobileMenuButton = () => {
    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const dataTheme = useSelector((state) => state.themeSetting.dataTheme); // GET THEME

    // Determine current theme
    const isDarkMode = dataTheme === 'dark-mode';
    const themeClass = isDarkMode ? 'dark' : 'light';

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!mobileMenuOpen);
    };

    const closeMobileMenu = () => {
        setMobileMenuOpen(false);
    };

    // Close menu when clicking outside (optional)
    useEffect(() => {
        const handleEscape = (e) => {
            if (e.key === 'Escape' && mobileMenuOpen) {
                closeMobileMenu();
            }
        };

        document.addEventListener('keydown', handleEscape);
        return () => {
            document.removeEventListener('keydown', handleEscape);
        };
    }, [mobileMenuOpen]);

    return (
        <>
            <div className={styles.mobileMenuButton}>
                <div className={styles.menuNav}>
                    <nav
                        aria-label="Site"
                        className={styles.menuNavContainer}
                    >
                        <ul className={styles.menuList}>
                            <li className={styles.menuItem}>
                                <div className={styles.menuItemWrapper}>
                                    <div className={styles.menuLinkContainer}>
                                        <a
                                            href="https://kapturestudio.wixstudio.com/howzit"
                                            className={styles.menuLink}
                                        >
                                            <div className={styles.menuText}>
                                                Home
                                            </div>
                                        </a>
                                    </div>
                                </div>
                                <span className={styles.menuDivider}></span>
                            </li>
                        </ul>
                        <div className={styles.menuOverlay}></div>
                    </nav>
                </div>
                <div className={styles.menuButtonContainer}>
                    <nav aria-label="Site" className={styles.buttonNav}>
                        <div className={styles.buttonWrapper}>
                            <button
                                type="button"
                                aria-label="Menu"
                                className={styles.menuButton}
                                onClick={toggleMobileMenu}
                            >
                                <span className={styles.buttonContent}>
                                    <span className={styles.buttonText}>Menu</span>
                                    <span className={styles.buttonIcon}>
                                        <span className={styles.iconWrapper}>
                                            <img
                                                src="https://c.animaapp.com/mhof1dcsmYxOSQ/assets/icon-5.svg"
                                                alt="Menu Icon"
                                                className={styles.menuIcon}
                                            />
                                        </span>
                                    </span>
                                </span>
                            </button>
                        </div>
                    </nav>
                </div>
            </div>

            {/* Mobile Menu Overlay - Updated with theme classes */}
            <div className={`${styles.mobileMenuOverlay} ${mobileMenuOpen ? styles.active : ''}`}>
                <div className={`${styles.mobileMenuContent} ${styles[themeClass]}`}>
                    <button className={styles.mobileCloseBtn} onClick={closeMobileMenu}>
                        <svg viewBox="0 0 32 32" width="24" height="24">
                            <path d="M.293.293a1 1 0 0 1 1.414 0L16 14.586 30.293.293a1 1 0 1 1 1.414 1.414L17.414 16l14.293 14.293a1 1 0 0 1-1.414 1.414L16 17.414 1.707 31.707a1 1 0 0 1-1.414-1.414L14.586 16 .293 1.707a1 1 0 0 1 0-1.414" fillRule="evenodd" fill={isDarkMode ? "#ffffff" : "#000000"} />
                        </svg>
                    </button>
                    <nav className={styles.mobileNav}>
                        <Link
                            to="/"
                            onClick={closeMobileMenu}
                            className={`${styles.mobileNavLink} ${styles[themeClass]}`}
                        >
                            Home
                        </Link>
                        <Link
                            to="/search-celeb"
                            onClick={closeMobileMenu}
                            className={`${styles.mobileNavLink} ${styles[themeClass]}`}
                        >
                            Search Celebrity
                        </Link>
                        <Link
                            to="/celebs"
                            onClick={closeMobileMenu}
                            className={`${styles.mobileNavLink} ${styles[themeClass]}`}
                        >
                            All Celebrities
                        </Link>
                        <Link
                            to="#"
                            onClick={closeMobileMenu}
                            className={`${styles.mobileNavLink} ${styles[themeClass]}`}
                        >
                            Events
                        </Link>
                        <Link
                            to="#"
                            onClick={closeMobileMenu}
                            className={`${styles.mobileNavLink} ${styles[themeClass]}`}
                        >
                            Merchandise
                        </Link>

                    </nav>
                </div>
            </div>
        </>
    );
};

export default MobileMenuButton;

